import { defineMessages } from 'react-intl';

export default defineMessages({
  tableHeaderBuilds: {
    id: 'frontbucket.dashboard.overview.pullRequestsTable.tableHeaderBuilds',
    description: 'Table header text for pull request build info',
    defaultMessage: 'Builds',
  },
  tableHeaderReviewers: {
    id: 'frontbucket.dashboard.overview.pullRequestsTable.tableHeaderReviewers',
    description: 'Table header text for pull request reviewers',
    defaultMessage: 'Reviewers',
  },
  tableHeaderActivity: {
    id: 'frontbucket.dashboard.overview.pullRequestsTable.tableHeaderActivity',
    description: 'Table header text for pull request activity',
    defaultMessage: 'Activity',
  },
  tableHeaderCreated: {
    id: 'frontbucket.dashboard.overview.pullRequestsTable.tableHeaderCreated',
    description: 'Table header text for when the pull request was created',
    defaultMessage: 'Created',
  },
});
